query TrainingFile($id: UUID!) {
  trainingFile(id: $id) {
    sharedDocumentFile {
      _downloadLink
      iconType
    }
  }
}
